import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ArticleTable = class ArticleTable extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-article-table';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.$tableRows = this.$element.find('tbody tr');
        this.headingTitles = Array.from(this.$element.find('thead th')).map((cell) => $(cell).text());

        if (!this.headingTitles.length) {
            this.headingTitles = this.fetchFirstRowsCellData();
        }
    }

    fetchFirstRowsCellData() {
        return this.$tableRows.first().find('td').map((cell, value) => value.innerHTML);
    }

    setTableCellDataAttrs() {
        const _this = this;

        this.$tableRows.each((i, row) => {
            const $row = $(row);
            const $cells = $row.find('td');

            $cells.each((i, cell) => {
                cell.setAttribute('data-title', _this.headingTitles[i]);
                $(cell).wrapInner('<span></span>');
            });
        });
    }

    render() {
        this.setVars();

        this.setTableCellDataAttrs();
    }
};



// WEBPACK FOOTER //
// ./components/articleTable/scripts/articleTable.js